import axios from 'axios';

import { webSocketApiUrlsDictionary } from '../constants';

const theme = localStorage.getItem('theme');

const defaultUrl = webSocketApiUrlsDictionary[theme]?.gatewayUrl || process.env.REACT_APP_API_GATEWAY_URL;

const BASE_URL = `${defaultUrl}/mk-ms-smartcharging`;

type Headers = {
  Authorization?: string;
  Platform: string;
};

type GetMeterDeviceProps = {
  macAddress?: string;
  deviceRemoteId?: string;
};

const defaultHeaders: Headers = {
  Platform: 'DASHBOARD'
};

const token = localStorage.getItem('auth-token');

if (token) {
  defaultHeaders.Authorization = `Bearer ${token}`;
}

const offsetInMinutes = new Date().getTimezoneOffset();

const timezoneOffset = -(offsetInMinutes / 60);

export const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    ...defaultHeaders,
    'X-Timezone-Offset': timezoneOffset
  },
});

export const getSmartCharging = (id: string) => {
  try {
    return api.get(`/smart-charging/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response;
    } else {
      throw error;
    }
  }
};

export const createSmartCharging = (data: any) => {
  try {
    return api.post('/smart-charging', { ...data });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response;
    } else {
      throw error;
    }
  }
};

export const updateSmartCharging = (id: string, data: any) => {
  try {
    return api.put(`/smart-charging/${id}`, { ...data });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response;
    } else {
      throw error;
    }
  }
};

export const getMeterDevice = ({ macAddress, deviceRemoteId }: GetMeterDeviceProps) => {
  try {
    return api.get('/meters/measurements', { params: { mac_address: macAddress, device_remote_id: deviceRemoteId } });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response;
    } else {
      throw error;
    }
  }
};

export const getMeterDeviceLists = (deviceRemoteIds: string[] | string | null) => {
  try {
    if (!deviceRemoteIds || !deviceRemoteIds.length) return;

    const deviceRemoteIdFormatted = typeof deviceRemoteIds === 'string' ? deviceRemoteIds : deviceRemoteIds.join(',');

    return api.get('/meters/measurements/list', {
      params: { device_remote_ids: deviceRemoteIdFormatted },
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response;
    } else {
      throw error;
    }
  }
};

// Simulador (MV2-2006): roda os dois algoritmos no smartcharging, sem gravar nada
export const simulateSmartCharging = (scenario: any) =>
  api.post('/smart-charging/simulation', scenario);

export const getSmartChargingSimulationScenario = (smartChargingId: string) =>
  api.get(`/smart-charging/${smartChargingId}/simulation`);

export const getSmartChargingSimulationChargeBoxes = (chargeBoxIds: string[]) =>
  api.post('/smart-charging/simulation/charge-boxes', chargeBoxIds);
